import { FormattedMessage } from 'react-intl';
import { BannerStatus, BannerLayout } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Checkbox } from 'ui-components/components/checkbox';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import styles from './styles.module.less';
import { AddCsvFile } from '../../../../../../../components/csv-import/ui/components/add-csv-file';
import { useImportContext } from '../../../../../../../components/csv-import/ui/components/import-context';
import { ImportDescription } from '../../../../../../../components/csv-import/ui/components/import-description';
import { InitErrors } from '../../../../../../../components/csv-import/ui/components/init-errors/init-errors';
import { MappingList } from '../../../../../../../components/csv-import/ui/components/mapping-list/mapping-list';
import { StepHeader } from '../../../../../../../components/csv-import/ui/components/step-header/step-header';
import { StepSuspense } from '../../../../../../../components/csv-import/ui/components/step-suspense/step-suspense';
import { useSellerShipStationFulfillmentProvider } from '../../../../../../../hooks/use-shipstation-fulfillment-whitelabel-enabled';
import { linkIDs } from '../../../../../../../services/link-service/links';
import { WorkflowSteps } from '../../../../../../../tracking/use-workflow-tracking';
import { UPDATE_EXISTING_PRODUCTS } from '../reducer';

const exampleFile = '/s3/marketplaces/shipstation/ProductImportSample.csv';

export const ConfigStepBody = () => {
  const { form, dispatch, isGetMappingsLoading, isInitImportLoading, trackProcess } = useImportContext();

  const sellerShipStationFulfillmentProvider = useSellerShipStationFulfillmentProvider();
  const isShipStationFulfillmentEnabled = !!sellerShipStationFulfillmentProvider;

  return (
    <StepSuspense isLoading={isGetMappingsLoading || isInitImportLoading}>
      <StepHeader>
        <FormattedMessage {...messages.uploadFile} />
      </StepHeader>
      <ImportDescription articleId={linkIDs.ImportCsvDangerousGoods} file={exampleFile} message={messages.helpContentText} />
      <InitErrors />
      <AddCsvFile name='product-import' />
      <Checkbox
        checked={form.updateExistingProducts}
        className={styles['update-checkbox']}
        label={<FormattedMessage {...messages.updateExistingProducts} />}
        onChange={() => {
          const newValue = !form.updateExistingProducts;

          dispatch({
            type: UPDATE_EXISTING_PRODUCTS,
            updateExistingProducts: newValue,
          });
          trackProcess(WorkflowSteps.CSV_IMPORT_CHANGE_CUSTOM_PROPERTY, {
            property: 'updateExistingProducts',
            value: newValue,
          });
        }}
      />
      {form.updateExistingProducts && isShipStationFulfillmentEnabled ? (
        <BannerMessageV2
          content={<Text textType={TextType.Caption} value={messages.fulfillmentBarcodeWarningMessage} />}
          layout={BannerLayout.Inline}
          status={BannerStatus.Warning}
        />
      ) : null}
      <FlexColumn className={styles['mapping-list-wrapper']}>
        <MappingList />
      </FlexColumn>
    </StepSuspense>
  );
};
